import React from "react"

// Small downward chevron shared by the column-header and row-actions menus;
// rotates 180° when its menu is open.
export const Chevron: React.FC<{ open: boolean }> = ({ open }) => (
  <svg
    className={`fsp-admin__hmenu-chevron ${open ? "fsp-admin__hmenu-chevron--open" : ""}`}
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    aria-hidden
  >
    <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
